<script>
	export let qrList = [];
	export let type = "";
	export let tag = "";
	export let toAssign = false;
	
	let selectedQR = { label: tag, value: tag };

    import { post } from "../js/labit-connection";
	import Combobox from "./Combobox.svelte";
	import { createEventDispatcher } from "svelte";

	const dispatch = createEventDispatcher();

	function dispatchOwnedQR() {
		dispatch("dispatchedOwnQR", {
			qr: selectedQR.label,
			type: selectedQR.type
		});
	}

	function dispatchSelectedQR() {
		dispatch("dispatchedQR", {
			qr: selectedQR.label
		});
	}

	const setQR = async (event) => {
        selectedQR.label = event.detail.selectedQR;
        let categAndTypeQuery = `select category, type from inventory where tag = "${selectedQR.label}";`;
		let categAndType = await post( categAndTypeQuery );

		//console.log(categAndType);
		type = categAndType[0].type || categAndType[0].category;
	} 

</script>

<div class="container flex">
	{#if type.toLowerCase() === "computer" || type.toLowerCase() === "pc"}
		<img class="icon pointer" src="/images/computer.svg" alt="" />
	{:else if type.toLowerCase() === "laptop"}
		<img class="icon pointer" src="/images/laptop.svg" alt="" />
	{:else if type.toLowerCase() === "monitor"}
		<img class="icon pointer" src="/images/monitor.svg" alt="" />
	{:else if type.toLowerCase() === "powercube"}
		<img class="icon pointer" src="/images/powercube.svg" alt="" />
	{:else if type.toLowerCase() === "wireless"}
		<img class="icon pointer" src="/images/wireless.svg" alt="" />
	{:else if type.toLowerCase() === "webcam" || type.toLowerCase() === "camera" ||  type.toLowerCase() === "cam"}
		<img class="icon pointer" src="/images/webcam.svg" alt="" />
	{:else if type.toLowerCase() === "headphones" || type.toLowerCase() === "earphones" || type.toLowerCase() === "headset"}
		<img class="icon pointer" src="/images/headphones.svg" alt="" />
	{:else}
		<img class="icon pointer" src="/images/unknown.svg" alt="" />
	{/if}
	
	<!-- <input type="text" name="" id="" value="{type}"/> -->
	<span>{type}</span>
	<Combobox
		options={qrList}
		selectedValue={selectedQR}
		preSelectedValue={tag}
		width="100%"
		persistentText="true"
		preSelectedOption ="true"
		on:selectedOption={setQR}
	/>
	{#if toAssign}
		<button class="pointer" on:click={dispatchOwnedQR}> Own </button>
	{/if}
	<img class="icon pointer" src="/images/edit.svg" alt="" on:click={dispatchSelectedQR}/>
	<img class="icon pointer" src="/images/x-red.svg" alt="" on:click={null}/>
</div>

<style>
	.container {
		height: 30px;
		border-radius: 40px;
		width: 40%;
    	margin: 20px 40px 20px 40px;
	}

	button {
		margin: 0 5px 0 20px;
		border-radius: 10px;
		background-color: #d7e1ea;
		border: none;
	}

	.container:hover {
		background-color: #ffffff;
	}

	.flex {
		align-items: center;
		justify-content: space-between;
		display: flex;
	}

	.w-100 {
		width: 100% !important;
	}
	.padding {
		padding: 0 10px 0 10px;
	}

	.h-100 {
		height: 100% !important;
	}

	.icon {
		width: 24px;
		margin: 0 10px 0 10px;
	}

    .pointer {
        cursor: pointer;
    }

	span {
		width: 500px;
		padding-left: 15px;
	}
/*
	input[type="text"] {
		border: none;
		text-align: center;
	}
*/
</style>
